import React, { useRef } from "react";
import moment from "moment";

const DatePicker = ({ label, date, onDateChange, className = "" }) => {
  const inputRef = useRef(null);

  const openCalendar = () => {
    if (inputRef.current?.showPicker) {
      inputRef.current.showPicker();
    } else {
      inputRef.current?.focus();
    }
  };

  return (
    <div className={`relative ${className}`}>
      <div
        className="
          relative flex items-center
          px-3 py-1
          text-sm text-gray-700
          bg-gray-50
          border border-gray-200
          rounded-lg
          shadow-sm
          cursor-pointer
          hover:border-gray-300
          hover:bg-gray-100
          transition-all duration-200
        "
        onClick={openCalendar}
      >
        <span className="min-w-[85px]">
          {date
            ? moment(date).format("MMM D YYYY")
            : "Select date"}
        </span>

        {/* Invisible native date input */}
        <input
          ref={inputRef}
          type="date"
          value={date || ""}
          onChange={(e) => onDateChange(e.target.value)}
          className="
            absolute
            inset-0
            w-full
            h-full
            opacity-0
            cursor-pointer
            z-10
          "
          aria-label={label || "Select date"}
        />
      </div>
    </div>
  );
};

export default DatePicker;